import { logout } from "../../auth/login/Auth";

export const CommonEndpoint = {
  country: "country",
  region: "region",
  state: "state",
  area: "area",
  subArea: "subArea",
  course: "course",
  lookup: "lookup",
  courseLevel: "courseLevel",
  school: "school",
  downloadLoginGif: "us/loginAnimationGif",
  fileDelete: "file/delete",
  downlodMyprofile: "file/myprofile",
  logout: "user/logout",
};
